import {
  Analytics,
} from '@material-ui/icons';

import paths from 'paths';
import { ccTypes } from 'store/constant';

export default {
  id: 'analytics-menu',
  type: 'group',
  children: [
    {
      id: 'analytics',
      title: 'Analytics',
      type: 'collapse',
      ccTypesAllowed: [ccTypes.internal],
      children: [
        {
          id: 'analytics',
          title: 'Base analytics',
          type: 'item',
          url: `${paths.analytics.reverse()}`,
          icon: Analytics,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal],
        },
        {
          id: 'rotation-analytics',
          title: 'Rotation analytics',
          type: 'item',
          url: `${paths.analyticsRotation.reverse()}`,
          icon: Analytics,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal],
        },
        {
          id: 'preceptor-analytics',
          title: 'Preceptor analytics',
          type: 'item',
          url: `${paths.analyticsPreceptor.reverse()}`,
          icon: Analytics,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal],
        },
        {
          id: 'cc-time',
          title: 'CC analytics',
          type: 'item',
          url: `${paths.analyticsCCTime.reverse()}`,
          icon: Analytics,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal],
        },
        {
          id: 'pipeline',
          title: 'Pipeline & Fill Rate Analytics',
          type: 'item',
          url: `${paths.analyticsPipeline.reverse()}`,
          icon: Analytics,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal],
        },
      ],
    },
  ],
};
